document.addEventListener("DOMContentLoaded", function(event) {
    window.addEventListener("load", function () {
        if( elements = getElements(document.querySelectorAll('.historyElement'))) {
            elements.forEach(function (element) {

                let timeline = gsap.timeline({defaults: {}});

                let split = new SplitText(".historyElement .wrap .huge .line", {type:"words,chars"},"<");


                timeline
                    .to(split.chars, { y: "-100%", stagger: .2},"<")
                ;

                ScrollTrigger.create({
                    trigger: element,
                    pin: true,
                    scrub: true,
                    animation: timeline,
                    start: 'top 0%',
                    end: 'bottom center',
                    toggleActions: "play none none reverse",
                    //markers: true,
                });
            });
        }
    });
});
